var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wells-sub-header"},[(_vm.showVideoControls)?_c('video-controls-panel'):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }